import React from 'react';
import { Payment } from '../../../../../XV2';
import { useToggle } from '../../../../../hooks/toggle';
import moment from 'moment';
import { useCurrency } from '../../../../../hooks/currency';
import { PaymentReceiptOverlay } from '../../../../payment/receipt/overlay/PaymentReceiptOverlay';
import { isPaymentSuccessful } from '../../../../../util/isPaymentSuccessful';
import { XSButton } from '../../../../../xs/component/button/XSButton';
import { XSBox } from '../../../../../xs/component/box/XSBox';
import { XSText } from '../../../../../xs/component/text/XSText';
import { XSDialog } from '../../../../../xs/component/dialog/XSDialog';

interface Props {
    payment: Payment;
}

export function OrderHistoryPaymentListItem({ payment }: Props) {
    const { format } = useCurrency();
    const [isOpen, toggleIsOpen] = useToggle();

    return (
        <XSBox
            onClick={() => {
                const dialog = XSDialog.show(
                    <PaymentReceiptOverlay paymentId={payment.id} onClose={() => dialog.close()} />,
                );
            }}
            justify={'space-between'}>
            <div>
                <div>
                    {payment.locationName} • {payment.zoneName}
                </div>

                <XSText color={'text-secondary'}>{moment(payment.createdAt).format('D MMMM YYYY, HH:mm')}</XSText>
            </div>

            <XSButton color={isPaymentSuccessful(payment.status) ? 'success' : 'danger'}>
                {format(payment.amount, payment.currency)}
            </XSButton>
        </XSBox>
    );
}
